(function () {
  'use strict';
  const normalize = value => String(value || '').normalize('NFKD').toUpperCase().replace(/[^A-Z0-9]/g, '');
  // Motorola's published series definitions; do not infer other families by prefix.
  const radioSeries = [
    {brand: 'Motorola', name: 'XPR3000', models: ['XPR3300', 'XPR3500']},
    {brand: 'Motorola', name: 'XPR3000e', models: ['XPR3300e', 'XPR3500e']},
    {brand: 'Motorola', name: 'XPR7000', models: ['XPR7350', 'XPR7380', 'XPR7550', 'XPR7580']},
    {brand: 'Motorola', name: 'XPR7000e', models: ['XPR7350e', 'XPR7380e', 'XPR7550e', 'XPR7580e']}
  ];
  function seriesFor(value, brand) {
    const q = normalize(value).replace(/SERIES$/, '');
    return radioSeries.find(s => (!brand || normalize(brand) === normalize(s.brand)) &&
      (q === normalize(s.name) || q === normalize(s.brand + s.name)));
  }
  function radioMatches(radio, brand, model) {
    if (brand && radio.brand !== brand) return false;
    if (normalize(radio.model) === normalize(model).replace(/^MOTOROLA/, '')) return true;
    const listedSeries = seriesFor(radio.model, radio.brand);
    const requested = normalize(model).replace(/^MOTOROLA/, '');
    if (listedSeries && (!brand || listedSeries.brand === brand) && listedSeries.models.some(m => normalize(m) === requested)) return true;
    const series = seriesFor(model, brand);
    return Boolean(series && radio.brand === series.brand &&
      series.models.some(m => normalize(m) === normalize(radio.model)));
  }
  function seriesMatch(product, filters) {
    const series = seriesFor(filters.model, filters.brand) || seriesFor(filters.query, filters.brand);
    if (!series) return null;
    const radio = product.radios.find(r => r.brand === series.brand &&
      series.models.some(m => normalize(m) === normalize(r.model)));
    return radio ? 'Series match: ' + radio.brand + ' ' + radio.model + ' — confirm your exact model' : null;
  }
  function matches(product, filters) {
    if (filters.kind && product.kind !== filters.kind) return false;
    if (filters.brand && !product.radios.some(r => r.brand === filters.brand)) return false;
    if (filters.model && !product.radios.some(r => radioMatches(r, filters.brand, filters.model))) return false;
    if (!filters.query) return Boolean(filters.brand || filters.model);
    const q = normalize(filters.query);
    if (q.length < 3) return false;
    const knownModel = radioSeries.some(s => (!filters.brand || s.brand === filters.brand) && s.models.some(m => [normalize(m),normalize(s.brand+m)].includes(q)));
    if (knownModel || seriesFor(filters.query, filters.brand)) return product.radios.some(r => radioMatches(r, filters.brand, filters.query));
    return [product.sku, ...product.replacements, ...product.radios.map(r => r.model), ...product.radios.map(r => r.brand + ' ' + r.model)].some(v => normalize(v).includes(q));
  }
  function matchReason(product, filters) {
    const q = normalize(filters.query);
    if (q === normalize(product.sku)) return 'Exact part number';
    const replacement = product.replacements.find(v => normalize(v) === q);
    if (replacement) return 'Listed replacement for ' + replacement;
    if (filters.relatedSkus?.has(product.sku)) return 'Related option for this part number';
    const seriesReason = seriesMatch(product, filters);
    if (seriesReason) return seriesReason;
    if (filters.model) return 'Listed for ' + filters.brand + ' ' + filters.model;
    const radio = product.radios.find(r => normalize(r.model) === q || normalize(r.brand + r.model) === q);
    return radio ? 'Listed for ' + radio.brand + ' ' + radio.model : 'Matches your search — confirm compatibility';
  }
  function findProducts(products, filters) {
    const q = normalize(filters.query);
    const anchors = q ? products.filter(p => [p.sku, ...p.replacements].some(v=>normalize(v)===q)) : [];
    const relatedSkus = new Set(anchors.flatMap(p=>(p.related || []).map(r=>r.sku)));
    filters.relatedSkus = relatedSkus;
    return products.filter(p => matches(p,filters) || (relatedSkus.has(p.sku) && (!filters.kind || p.kind===filters.kind) && (!filters.brand || p.radios.some(r=>r.brand===filters.brand)) && (!filters.model || p.radios.some(r=>radioMatches(r,filters.brand,filters.model)))));
  }
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form'), brand = form.elements.brand, model = form.elements.model, query = form.elements.query, kind = form.elements.kind;
    const status = root.querySelector('[role="status"]'), list = root.querySelector('[role="list"]'), more = root.querySelector('.pp-more');
    const jump = root.querySelector('.pp-view-results'), edit = root.querySelector('.pp-edit-search');
    function moveTo(element) {
      element.focus({preventScroll:true});
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = Math.max(0, window.scrollY + element.getBoundingClientRect().top - 110);
      window.scrollTo({top, behavior:reducedMotion ? 'auto' : 'smooth'});
    }
    jump?.addEventListener('click', () => moveTo(status));
    edit?.addEventListener('click', () => moveTo(query));
    function resultControls(searched) {
      if (jump) {jump.hidden = !searched; jump.textContent = results.length ? 'View ' + results.length + ' results ↓' : 'View search result ↓';}
      if (edit) edit.hidden = !searched;
    }
    let products = [], results = [], shown = 0, active = {}, ready = false;
    const option = (label, value = label) => {const o = document.createElement('option'); o.textContent = label; o.value = value; return o;};
    function updateModels() {
      model.replaceChildren(option('Choose a radio model', ''));
      const models = new Set(products.flatMap(p => p.radios.filter(r => r.brand === brand.value).map(r => r.model)));
      radioSeries.filter(s => s.brand === brand.value && products.some(p => p.radios.some(r => radioMatches(r, s.brand, s.name)))).forEach(s => models.add(s.name));
      [...models].sort((a,b) => a.localeCompare(b, undefined, {numeric:true})).forEach(v => model.append(option(v)));
      model.disabled = !brand.value;
    }
    function renderMore() {
      const fragment = document.createDocumentFragment();
      results.slice(shown, shown + 24).forEach(p => {
        const card = document.createElement('article'); card.className = 'pp-result'; card.setAttribute('role', 'listitem');
        if (p.image) {const photo = document.createElement('img'); photo.src = p.image; photo.alt = p.title; photo.loading = 'lazy'; photo.width = 240; photo.height = 240; photo.style = 'width:100%;height:200px;object-fit:contain'; photo.addEventListener('error',()=>photo.remove(),{once:true}); card.append(photo);}
        const label = document.createElement('p'); label.className = 'pp-result-sku'; label.textContent = '(' + p.sku + ')';
        const title = document.createElement('h3'), link = document.createElement('a');
        const base = (root.dataset.root || '/').replace(/\/?$/, '/');
        link.href = base + 'products/' + encodeURIComponent(p.handle); link.textContent = p.title; title.append(link);
        const reason = document.createElement('p'); reason.className = 'pp-match'; reason.textContent = matchReason(p, active);
        const spec = document.createElement('p'); spec.textContent = p.summary;
        const category = document.createElement('p'); category.textContent = p.kind;
        card.append(category, label, reason, title, spec);
        if (p.related?.length) {
          const related = document.createElement('details'); related.className = 'pp-related';
          const heading = document.createElement('summary'); heading.textContent = 'Related options and accessories'; related.append(heading);
          const links = document.createElement('ul');
          p.related.forEach(item => {const li = document.createElement('li'), a = document.createElement('a'); a.href = base + 'products/' + encodeURIComponent(item.handle); a.textContent = item.sku + ' — ' + item.label; li.append(a); if(item.note) li.append(document.createTextNode(' (' + item.note + ')')); links.append(li);});
          related.append(links); card.append(related);
        }
        fragment.append(card);
      });
      list.append(fragment); shown = Math.min(shown + 24, results.length); more.hidden = shown >= results.length;
    }
    function search(event) {
      event?.preventDefault(); if (!ready) return;
      active = {brand:brand.value, model:model.value, query:query.value.trim(), kind:kind.value};
      list.replaceChildren(); shown = 0; more.hidden = true; results = []; resultControls(false);
      if (!active.brand && !active.model && normalize(active.query).length < 3) {status.textContent = 'Choose a radio brand or enter at least 3 letters or numbers.'; return;}
      results = findProducts(products, active);
      const q = normalize(active.query);
      results.sort((a,b) => {
        const exact = p => q && [p.sku, ...p.replacements, ...p.radios.map(r=>r.model)].some(v=>normalize(v)===q) ? 0 : 1;
        return exact(a)-exact(b) || a.title.localeCompare(b.title);
      });
      status.textContent = results.length ? results.length + ' matching ' + (results.length === 1 ? 'product' : 'products') : 'No listed matches. Check the part number or search by radio brand and model.';
      renderMore();
      resultControls(true);
      if (event?.type === 'submit') requestAnimationFrame(() => moveTo(status));
    }
    form.addEventListener('submit', search);
    form.addEventListener('reset', () => {requestAnimationFrame(() => {updateModels(); list.replaceChildren(); more.hidden = true; results = []; resultControls(false); status.textContent = 'Choose your radio or enter a battery part number.';});});
    brand.addEventListener('change', updateModels); model.addEventListener('change', search); kind.addEventListener('change', search); more.addEventListener('click', renderMore);
    fetch(root.dataset.source, {credentials:'same-origin'}).then(r => {if (!r.ok) throw new Error('Data unavailable'); return r.json();}).then(data => {
      if (!Array.isArray(data.products)) throw new Error('Invalid catalog');
      products = data.products; const brands = new Set(products.flatMap(p=>p.radios.map(r=>r.brand)));
      [...brands].sort().forEach(v=>brand.append(option(v))); brand.disabled = false; ready = true;
      status.textContent = 'Choose your radio or enter a battery part number.';
      const initialQuery = new URLSearchParams(window.location.search).get('q');
      if (initialQuery) {query.value = initialQuery.slice(0,100); search();}
    }).catch(() => {status.textContent = 'The finder could not load. Please try again or browse the battery collection.';});
  }
  function mount(scope) {scope.querySelectorAll('[data-pp-finder]').forEach(init);}
  if (typeof document !== 'undefined') {mount(document); document.addEventListener('shopify:section:load', event=>mount(event.target));}
  if (typeof module !== 'undefined' && module.exports) module.exports = {normalize, matches, matchReason, findProducts};
}());
